import { TypedArrayId, FormatTypeId } from '@jurinfor/typing';

export function extractTableDataForContext({ data }, ctx) {
  return data.map((row) => ctx.map((columnId) => row[columnId]));
}

export function extractTableDataForContexts(table, contextList) {
  FormatTypeId({ data: TypedArrayId(TypedArrayId((x) => x)) })(table);
  TypedArrayId(TypedArrayId((x) => x))(contextList);
  // формируем массив (по всем контекстам) данных, которые получаются из таблицы выделение столбцов, соответствующих контексту
  return contextList.map((ctx) => extractTableDataForContext(table, ctx));
}
